// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bookmark{width:20px;cursor:pointer;transition:.2s;position:absolute;right:15px;top:-8px}.bookmark svg{height:20px;width:auto;transition:.3s;fill:#dcdcdc}.bookmark.active svg{fill:#0ea5bf!important}", ""]);
// Exports
module.exports = exports;
